import { render, staticRenderFns } from "./MemberImage.vue?vue&type=template&id=2a22ea18&scoped=true&"
import script from "./MemberImage.vue?vue&type=script&lang=js&"
export * from "./MemberImage.vue?vue&type=script&lang=js&"
import style0 from "./MemberImage.vue?vue&type=style&index=0&id=2a22ea18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22ea18",
  null
  
)

export default component.exports